import * as React from 'react';
import { AudioButton, AudioRecorderUseMode } from '../../../_components/AudioRecorder/AbstractAudioView';
import { PlaybackState } from '../../../_components/AudioRecorder/AudioPlayer';
// import { AudioButton, AudioRecorderUseMode, PlaybackState } from '../../../_components/AudioRecorder';
import { PauseButtonIcon } from '../../../images/images';
import { buttonStyle, getRoundAudioButtonStyle } from './AudioStyles';

export function createPauseButton(size: number): AudioButton {
    const roundButtonStyle = getRoundAudioButtonStyle(size);
    return ({ mode, playbackState, recordingState, ...props }) => {
        return mode === AudioRecorderUseMode.Reviewing && playbackState === PlaybackState.Playing ? (
            <div {...props} style={{ ...roundButtonStyle, ...buttonStyle }}>
                <img style={roundButtonStyle} src={PauseButtonIcon} />
            </div>
        ) : null;
    };
}



// WEBPACK FOOTER //
// ./src/Pages/PhotoViewer/Audio/PauseButton.tsx